import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const CloseIcon16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color || '#0F172A'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4 12 8-8M4 4l8 8"
    />
  </Svg>
);
export default CloseIcon16;
